import { createContext, useContext, useState, useEffect } from "react";
import en from "./en";
import nl from "./nl";
import de from "./de";
import it from "./it";
import es from "./es";
import sq from "./sq";

const dicts = { en, nl, de, it, es, sq };
export const SUPPORTED = ["en", "nl", "de", "it", "es", "sq"];
export const LANG_NAMES = Object.fromEntries(SUPPORTED.map((c) => [c, dicts[c].langName]));

function detect() {
  try {
    const saved = localStorage.getItem("ee-lang");
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch (e) { /* ignore */ }
  const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
  return SUPPORTED.includes(nav) ? nav : "en";
}

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: en });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detect);
  const setLang = (l) => {
    try { localStorage.setItem("ee-lang", l); } catch (e) { /* ignore */ }
    setLangState(l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangCtx.Provider value={{ lang, setLang, t: dicts[lang] || en, languages: SUPPORTED }}>
      {children}
    </LangCtx.Provider>
  );
}

export const useLang = () => useContext(LangCtx);
